(function centerActiveAnchor() {
    let container = document.querySelector('.sidebar-template')
    let activeLink = container.querySelector('.active')

    if (container && activeLink) {
        activeLink.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' })
    }
})();
